<template>
    <div>
        <Navbar />
        <div class="columns">
            <SideBar class="menu-sidebar" />
            <div id="critical-page" class="qi-content">
                <header>
                    <h1>Turmas Críticas</h1>
                </header>

                <vs-row>
                    <NewSale />
                </vs-row>
                
                <vs-row vs-justify="left" class="filters-row">
                    <vs-col vs-w="4" vs-xs="12">
                        <label><b>Curso *</b></label>
                        <vs-select v-model="curso" autocomplete placeholder="Selecione um Curso" label-placeholder="Curso">
                            <vs-select-item
                                v-for="c in cursos"
                                :key="c.value"
                                :value="c.value"
                                :text="c.text"
                            />
                        </vs-select>
                    </vs-col>

                    <vs-col vs-w="4" vs-xs="12" :style="filterVisibility">
                        <label>Filial</label>
                        <vs-select v-model="filial" @change="applyFilters" autocomplete>
                            <vs-select-item value="" text="Todas as Filiais" />
                            <vs-select-item
                                v-for="fil in filiais"
                                :key="fil.value"
                                :value="fil.value"
                                :text="fil.text"
                            />
                        </vs-select>
                    </vs-col>

                    <vs-col vs-w="4" vs-xs="12" :style="filterVisibility">
                        <label>Data</label>
                        <vs-input type="date" v-model="data" />
                    </vs-col>

                    <vs-col vs-w="4" vs-xs="12" style="display:flex; align-items:flex-end">
                        <vs-button color="danger" @click="fetchClasses" icon="refresh">Pesquisar Turmas Críticas</vs-button>
                    </vs-col>
                </vs-row>

                <vs-row>
                    <vs-col vs-w="12">
                            <vs-row>
                            <vs-col
                                vs-w="12"
                                vs-xs="12"
                                v-if="filteredClasses.length === 0 && !loading && hasSearched && !error"
                            >
                                <vs-alert title="Nenhuma turma crítica encontrada" color="warning" />
                            </vs-col>

                            <vs-col
                                vs-w="12"
                                vs-xs="12"
                                v-if="error"
                            >
                                <vs-alert :title="error" color="danger" />
                            </vs-col>
                        </vs-row>

                        <vs-row v-if="filteredClasses.length > 0 && !loading">
                            <vs-col vs-w="12">
                                <vs-table :data="filteredClasses" stripe class="pd-table">
                                    <template slot="thead">
                                        <vs-th width="12%" class="td-center">Desconto</vs-th>
                                        <vs-th>Filial</vs-th>
                                        <vs-th width="15%" class="td-center">Data de Início</vs-th>
                                        <vs-th width="15%">Turno</vs-th>                                            
                                        <vs-th width="15%">Turma</vs-th>
                                        <vs-th width="15%">Total Alunos</vs-th>
                                    </template>

                                    <template slot-scope="{ data }">
                                        <vs-tr 
                                            v-for="classData in data" 
                                            :key="classData.CODCURSO || classData.TURMA || classData.IDTURMADISC"
                                            :style="criticalStyle(classData.PERCBOLSATURMACRITICA)"
                                        >
                                            <vs-td :data="classData.PERCBOLSATURMACRITICA" class="td-center">
                                                <small 
                                                    v-if="classData.PERCBOLSATURMACRITICA && classData.PERCBOLSATURMACRITICA !== '0.00'"
                                                    style="font-weight:bold;color:#8B0000"
                                                >
                                                    {{ classData.PERCBOLSATURMACRITICA }}%
                                                </small>
                                            </vs-td>

                                            <vs-td :data="classData.FILIAL"> 
                                                {{ classData.FILIAL }} 
                                            </vs-td>

                                            <vs-td :data="classData.DTINICIAL" class="td-center"> 
                                                {{ formatDate(classData.DTINICIAL) }} 
                                            </vs-td>

                                            <vs-td :data="classData.TURNO"> 
                                                {{ classData.TURNO }} 
                                            </vs-td>

                                            <vs-td :data="classData.TURMA"> 
                                                {{ classData.TURMA }} 
                                            </vs-td>
                                            <vs-td :data="classData.NUMEROALUNOS" class="td-center"> 
                                                {{ classData.NUMEROALUNOS }} 
                                            </vs-td>                                              
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from "../main";
import SideBar from "../components/Dashboard/SideBar.vue";
import NewSale from "../components/DynamicInput.vue";
import moment from "moment";
import CoursesService from "../services/courses";

export default {
    name: "Critical",
    components: {
        SideBar,
        NewSale,
    },
    data: () => ({
        classes: [],
        filteredClasses: [],
        filial: "",
        curso: null,
        data: null, 
        cursos: [],   
        filiais: [],
        error: null,
        loading: false,
        hasSearched: false,
    }),

    computed: {
        filterVisibility() {
            if(this.curso) {
                return { visibility: 'visible' };
            } else {
                return { visibility: 'hidden' }
            }
        }
    },
    
    mounted() {
        this.loadFilters();
    },
    
    created() {
        bus.$emit("updateSteps", 0);
    },

    methods: {
        loadFilters() {
            this.fetchCursosParaFiltro();
        },

        fetchCursosParaFiltro() {
            new CoursesService()
                .fetchCourses() 
                .then((res) => {
                    const coursesList = res.data;
                    this.cursos = coursesList.map(course => ({
                        value: course.CODCURSO, 
                        text: course.NOMECOMERCIAL
                    }));
                })
                .catch(() => {
                    this.error = "Erro ao carregar a lista de cursos.";
                });
        },

        populateFilialFilter(classes) {
            const filiaisUnicas = new Map();

            classes.forEach(turma => {
                const codFilial = turma.CODFILIAL;
                const nomeFilial = turma.FILIAL;

                if (codFilial && !filiaisUnicas.has(codFilial)) {
                    filiaisUnicas.set(codFilial, {
                        value: codFilial,
                        text: nomeFilial
                    });
                }
            });

            this.filiais = Array.from(filiaisUnicas.values());
        },

        fetchClasses() {
            this.hasSearched = true;
            this.$vs.loading({ color: "danger" });
            this.loading = true; 

            if (!this.curso) {
                this.error = "É necessário selecionar um curso para a busca."
                this.$vs.loading.close(); 
                this.loading = false;
            }

            const dataEnvio = this.data ? this.data : moment().format('YYYY-MM-DD');
            const filialEnvio = 0; 
            this.error = null;
            this.classes = [];
            this.filteredClasses = []; 

            new CoursesService()
                .getCritical( dataEnvio, this.curso, filialEnvio )
                .then(({ data }) => {
                    console.log("Payload recebido: ", data);
                    const classes = Array.isArray(data) ? data : [data];
                    if (filialEnvio === 0) {
                        this.populateFilialFilter(classes);
                    }

                    this.classes = classes;
                    this.applyFilters();
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.error) {
                        this.error = error.response.data.error;
                    } else {
                        this.error = "Erro ao buscar turmas.";
                    }
                })
                .finally(() => {
                    this.$vs.loading.close();
                    this.loading = false;
                });
        },

        applyFilters() {
            this.filteredClasses = this.classes.filter((c) => {
                const fil = c.CODFILIAL || c.FILIALCAMPUS || c.FILIAL || "";
                // const curso = c.CODCURSO || c.NOMECURSO || ""; 
                if (this.filial && String(this.filial) !== String(fil)) return false;
                // if (this.curso && String(this.curso) !== String(curso)) return false;
                return true;
            });
            const parsePercent = (v) => {
                if (v === null || v === undefined) return 0;
                const s = String(v).replace('%', '').replace(',', '.').trim();
                const n = parseFloat(s);
                return isNaN(n) ? 0 : n;
            };

            const getPercentFrom = (obj) => {
                if (!obj) return 0;
                return parsePercent(obj.PERCBOLSATURMACRITICA || obj.PERCTURMACRITICA || obj.PERCTURMACRITICA || obj.PERCTURMACRITICA || obj.PERCTURMACRITICA);
            };

            this.filteredClasses.sort((a, b) => getPercentFrom(b) - getPercentFrom(a));
            console.log('filteredClasses (sorted):', this.filteredClasses);
        },

        criticalStyle(percent) {
            if (percent && percent !== "0.00") {
                return { borderLeft: '2px solid #800020', borderRight: '2px solid #800020', paddingLeft: '8px' };
            }
            return null;
        },

        formatDate(date) {
            if (!date) return "";
            return moment(date).format("DD/MM/YYYY"); 
        },

    }
};
</script>

<style>
#critical-page .choosable-card {
	cursor: default;
}

#critical-page .filters-row {
	margin-bottom: 16px;
}

.pd-table td, .pd-table th {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#critical-page .critical-border {
    border-left: 4px solid #800020;
}

.td-center {
    text-align: center;
}

@media (max-width: 1400px) {
    .pd-table table {
    table-layout: fixed;
    width: 100%;
    }
}
</style>
